// The fields of a Materials doc that the editor writes.
//
// EXTRACTED BECAUSE A FIELD WENT MISSING. The page used to spell this list out
// inline, twice — once for the update and once for the add — and UnitsPerItem
// was in neither. So the conversion factor could be filled in, showed as saved,
// and was dropped on the way to Firestore: every material stayed on status
// needs-factor and the CO2 total silently excluded it.
//
// One list, one test.
//
// TWEE SOORTEN, EEN LIJST. Sinds de coachadviezen erbij zijn gekomen schrijft
// dit ook Kind. Een advies wordt niet ingekocht, dus voorraad, drempel en prijs
// worden hier op 0 gezet in plaats van op wat er toevallig in het formulier
// stond. Dat is geen cosmetica: een advies met een voorraad wordt door
// planMaterialStockChange geweigerd zodra iemand het bij een huishouden
// registreert.
//
// EN HET SCHRIJFT DE INTERVENTIECODE — alleen bij een advies. Een materiaal
// vindt zijn interventie via zijn naam (materialInterventionDefaults); voor een
// advies bestaat die naam-naar-code-tabel niet, want de lijst komt uit de
// meetstandaard zelf. Zonder opgeslagen code telt een geregistreerd advies
// nergens mee, en dat is niet te zien aan de opgeslagen regel.
//
// UnitsPerItem is bij een advies altijd 1: je registreert het meteen in de
// registratie-eenheid van de standaard ('per huishouden', 'per graad te koud'),
// dus er valt geen verpakking om te rekenen.
//
// AI-CONTEXT: See docs/features/materials-co2-circulariteit.md

import { MATERIAL, ADVICE } from './materialCatalog'

/**
 * @typedef {object} MaterialWritePayload
 * @property {'material'|'advice'} Kind - Materiaal of coachadvies
 * @property {string} Title
 * @property {string} Description
 * @property {string} Unit - The product unit the organisation buys in
 * @property {number} QuantityInStock
 * @property {number} LowStockThreshold
 * @property {string} Category
 * @property {number} ItemPrice
 * @property {number|null} UnitsPerItem - Registration units per product unit; null = not filled in
 * @property {string} [InterventionCode] - Alleen bij een advies: de code uit de meetstandaard
 * @property {string} DisplayTitle - De naam die de organisatie zelf gaf; leeg = gebruik Title
 * @property {string} ArticleNumber - Het artikelnummer van de organisatie; leeg = geen
 */

const trimmed = (value) => (typeof value === 'string' ? value.trim() : '')

/**
 * @param {object} form - The MaterialsModal form as passed to onSave
 * @returns {MaterialWritePayload}
 */
const materialWritePayload = (form) => {
    // Alles wat geen bekende soort is, is een materiaal. Een onbekende waarde
    // doorschrijven zou een derde soort introduceren die nergens gerenderd wordt.
    const kind = form?.Kind === ADVICE ? ADVICE : MATERIAL
    const isAdvice = kind === ADVICE

    const base = {
        Kind: kind,
        Title: form?.Title || '',
        Description: form?.Description || '',
        Unit: form?.Unit || '',
        QuantityInStock: isAdvice ? 0 : (Number(form?.QuantityInStock) || 0),
        LowStockThreshold: isAdvice ? 0 : (Number(form?.LowStockThreshold) || 0),
        Category: form?.Category || '',
        ItemPrice: isAdvice ? 0 : (Number(form?.ItemPrice) || 0),
        // Never coerced to 0: a missing factor is a blank, not a measurement of
        // zero. The resolver reads 0 as "not filled in" too, but storing it would
        // make the two indistinguishable in the data itself.
        UnitsPerItem: typeof form?.UnitsPerItem === 'number' && form.UnitsPerItem > 0
            ? form.UnitsPerItem
            : null,
        // Ook voor een MATERIAAL, niet alleen voor een advies. Stond eerder op
        // de advies-tak, waardoor een materiaal met een eigen productnaam niet
        // koppelbaar was — en dat is 60% van wat organisaties registreren
        // ("Radiatorfolie 40cm (TZ410601)" staat niet in de koppeltabel).
        // Leeg = val terug op de tabel, niet = geen koppeling.
        // AI-CONTEXT: docs/inbox.md (bug #119)
        InterventionCode: form?.InterventionCode || '',
        // De eigen naam van de organisatie, naast en niet in plaats van Title.
        // Title blijft de standaardnaam en voedt de koppeling aan de
        // meetstandaard, dus hernoemen kan de CO2-berekening niet raken.
        // AI-CONTEXT: See docs/features/materials-own-name-and-article-number.md
        DisplayTitle: trimmed(form?.DisplayTitle),
        ArticleNumber: trimmed(form?.ArticleNumber),
    }

    if (!isAdvice) return base

    // Een advies registreer je meteen in de eenheid van de standaard, dus daar
    // valt niets om te rekenen. En je koopt het niet in: geen verpakking om een
    // eigen naam aan te geven, geen artikelnummer om te bestellen. Hier
    // leeggemaakt en niet alleen verborgen, anders reist de waarde van het
    // vorige gekozen materiaal mee naar Firestore.
    return { ...base, UnitsPerItem: 1, DisplayTitle: '', ArticleNumber: '' }
}

export default materialWritePayload
